export enum ExtrasTypesEnum {
  Baggage = 'Bagage',
  SpecialBaggage = 'Bijzondere bagage',
  LoungeAccess = 'Lounge access',
  PriorityBoarding = 'Priority boarding',
  Meals = 'Maaltijden',
  MedicalAssistance = 'Medische assistentie',
}

export type ExtrasTypesEnumType = keyof typeof ExtrasTypesEnum;
